import "./utilities_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.searchParams = (fieldElements) =>
  window.Sparkle.Utilities.paramsToObject(jQuery(fieldElements).serialize());

window.Sparkle.Utilities.paramsToObject = (serializedParams) => {
  const params = {};
  if (serializedParams) {
    serializedParams = serializedParams.replace(/\+/g, " "); // Convert pluses to spaces
    serializedParams = serializedParams.replace(/^\?/, ""); // Remove leading `?`
    jQuery.each(serializedParams.split("&"), (i, item) => {
      const keyVal = item.split("=");
      return (params[decodeURIComponent(keyVal[0])] = decodeURIComponent(keyVal[1]));
    });
  }

  // Remove empty keys
  window.Sparkle.Utilities.sanitizeParams(params);

  return params;
};

window.Sparkle.Utilities.paramsFromObject = (paramsObject) => {
  // Remove empty keys
  paramsObject = window.Sparkle.Utilities.sanitizeParams(paramsObject);

  let path = jQuery.param(paramsObject);

  if (path !== "") {
    path = "?" + path;
  }

  path = path.replace(/%20/g, "+"); // Backbone Router.navigate does not realize that %20 is the same as a space and will trigger navigate callbacks even if we're already at that url

  return path;
};

window.Sparkle.Utilities.sanitizeParams = (params, defaults = {}) => {
  params = {
    ...params,
  };

  params = window.Sparkle.Utilities.removeBlankParams(params);

  params = _.defaults(params, defaults); // Add these after removing empty keys but before sorting so they become sorted too

  // Sort keys. This avoids having permutations of the same url when we turn the object into a param string
  const orderedParams = {};
  Object.keys(params)
    .sort()
    .forEach((key) => (orderedParams[key] = params[key]));

  return orderedParams;
};

// Merges two sets of params, ignoring any blank keys from params2 that would have no effect on the final url string
window.Sparkle.Utilities.mergeParams = (params1, params2) => {
  const merged = {
    ...params1,
  };

  jQuery.each(params2, (key, value) => {
    if (jQuery.trim(params1[key]) !== "" || jQuery.trim(value) !== "") {
      return (merged[key] = value);
    }
  });

  return merged;
};

window.Sparkle.Utilities.removeBlankParams = (params) => {
  params = {
    ...params,
  };

  jQuery.each(params, (key, val) => {
    if (val === "" || val === null || val === undefined) {
      return delete params[key];
    }
  });

  return params;
};
